export default __webpack_public_path__ + "static/rule-05-natural-breath-83a83dd21361626dfc1eb8609b3781aa.png";